import { render } from "./zdsx.vue?vue&type=template&id=840c8a06&scoped=true&ts=true"
import script from "./zdsx.vue?vue&type=script&lang=ts"
export * from "./zdsx.vue?vue&type=script&lang=ts"

import "./zdsx.vue?vue&type=style&index=0&id=840c8a06&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-840c8a06"]])

export default __exports__